import { Bars3Icon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';

import { Brand } from './Brand';
import { DesktopNavbar } from './DesktopNavbar';
import { MobileNavbar } from './MobileNavbar';
import { MobileNavItems } from './mobile-items/MobileNavItems';
import { items } from './types';

interface NavbarProps {
  isFixed?: boolean;
}

export function Navbar(props: NavbarProps) {
  const { isFixed = false } = props;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header
      className={clsx('bg-white w-full border-b border-neutral-200', {
        'fixed top-0 z-50': isFixed,
      })}
    >
      <nav
        aria-label="Global"
        className="mx-auto flex max-w-7xl items-center justify-between p-4"
      >
        <div className="flex lg:flex-1">
          <Brand className="-m-1.5 p-1.5" />
        </div>
        <div className="flex lg:hidden flex-1 gap-5 justify-end items-center">
          {/* This part is not visible on desktop screens */}
          <MobileNavItems items={items} />
          <OpenButton setMobileMenuOpen={setMobileMenuOpen} />
        </div>
        <DesktopNavbar items={items} />
      </nav>
      <MobileNavbar
        items={items}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
    </header>
  );
}

interface OpenButtonProps {
  setMobileMenuOpen: Dispatch<SetStateAction<boolean>>;
}

function OpenButton(props: OpenButtonProps) {
  const { setMobileMenuOpen } = props;

  return (
    <button
      type="button"
      onClick={() => setMobileMenuOpen(true)}
      className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-neutral-700"
    >
      <span className="sr-only">Open main menu</span>
      <Bars3Icon aria-hidden="true" className="size-6" />
    </button>
  );
}
